const ETHOL_DATA_URL = "https://data.etholvants.com/etholdata.json";

let etholDataPromise = null;

export function fetchEtholData() {
    if (!etholDataPromise) {
        etholDataPromise = fetch(ETHOL_DATA_URL)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Failed to load Etholvants data: ${response.status}`);
                }

                return response.json();
            })
            .catch((error) => {
                etholDataPromise = null;
                throw error;
            });
    }

    return etholDataPromise;
}
